import * as React from "react";

import { QuestionSet } from "../../QuestionSet";
import { getQuestionSetAnswers } from "../../../util/getQuestionSetAnswers";

type TProps = {
  inputForm: TQuestionSet;
  value: TRiskData;
  onChange: (result) => void;
};

export const FormInput: React.FC<TProps> = (props) => {
  const { inputForm, value, onChange, ...restProps } = props;
  // This function is a little annoying; it transforms from ID keys to
  // storage path keys. It's only needed because Yup can't handle
  // periods in the field name.
  function handleChange(values) {
    const result = {};
    for (const [k, v] of Object.entries(values)) {
      const question = inputForm.questions.find((q) => q.id == k);
      result[question.storagePath] = v;
    }
    onChange?.(result);
  }
  return (
    <QuestionSet
      {...restProps}
      initialValues={getQuestionSetAnswers(inputForm, value)}
      onChange={handleChange}
      questionSet={inputForm}
      noNextButton
    />
  );
};
